// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__WHpol","open":"sidebar_open__lWQRP","li":"sidebar_li__tYEKK"};